import React, { useState } from 'react';
import { Modal, Button, TextField, Alert } from '@dopomogai/ui';

export interface RotateSecretModalProps {
  isOpen: boolean;
  onClose: () => void;
  secretName: string;
  onRotate: (newPlaintextValue: string) => Promise<void>;
}

export const RotateSecretModal: React.FC<RotateSecretModalProps> = ({ isOpen, onClose, secretName, onRotate }) => {
  const [value, setValue] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const handleRotate = async () => {
    setErr(null);
    if (!value.trim()) {
      setErr('New secret value is required.');
      return;
    }
    setSubmitting(true);
    try {
      await onRotate(value);
      setValue('');
      onClose();
    } catch (e: any) {
      setErr(e?.message || 'Failed to rotate secret.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => !submitting && onClose()}
      title={`Rotate secret: ${secretName}`}
      size="md"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} disabled={submitting}>Cancel</Button>
          <Button variant="primary" onClick={handleRotate} disabled={submitting}>
            {submitting ? 'Rotating…' : 'Rotate'}
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-slate-600">
          Rotating will replace the current value. You won’t be able to see it again after saving.
        </p>
        {err && <Alert type="error" message={err} />}
        <TextField
          label="New value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="••••••••"
          type="password"
        />
      </div>
    </Modal>
  );
};